import {useAppSelector} from '../../hooks';
import {
  getCustomerBranding,
  selectCustomerBranding,
  selectCustomerBrandingLoadingStatus,
} from '../../data/customerBranding';
import {useDispatch} from 'react-redux';
import {useEffect} from 'react';
export const useCustomerBranding = (props: {enabled?: boolean} = {enabled: true}) => {
  const dispatch = useDispatch();
  const branding = useAppSelector(selectCustomerBranding);
  const loadingStatus = useAppSelector(selectCustomerBrandingLoadingStatus);

  useEffect(() => {
    if (!props.enabled) return;
    dispatch(getCustomerBranding());
  }, [dispatch, props.enabled]);

  return {branding, loadingStatus};
};
